
<script>
	import listBase from '@_system/components/base/list.vue'
	import moduleTree from '@_system/components/formcomponents/common/select/module/tree.vue'
	export default {
		extends: listBase,
		name: 'moduleIndex',
		props: {

		},
		render(h) {
			this.$slots.mainheader = [
				<el-button size="mini" type="primary" onClick={this.listfieldconfig}>列表字段</el-button>]
			this.$slots.aside = [
				<module-tree ref="moduletTree" key={this.moduletTreeKey} onSelect={this.moduletTreeChange} />
			]
			this.$slots.header = [
				<el-breadcrumb separator-class="el-icon-arrow-right" >
					{
						this.parentbread.length!=0?this.parentbread.map((item,index)=>{
						return <el-breadcrumb-item key={index}>{item.name}</el-breadcrumb-item>
					}):<el-breadcrumb-item>模块列表</el-breadcrumb-item>
					
					}			
				</el-breadcrumb>
			]

			return listBase.render.call(this, h)
		},
		data() {
			return {
				componenttype: 'system',
				moduleName: 'modulecontroll',
				windowName: '模块管理',
				moduleid: 0,
				gridShow:false,
				// modulename: '',
				field: '',
				parentbread: [],
				toolbarbutton: [],
				operatebutton: [],
				moduletTreeKey: Math.random(),
				formModule: {
					component: '',
					name: '',
					id: 0,
					show: false,
					controlltype: 1,
					extra: {},
					foreingKey: {},
				},
				listShow: true,
				listformData: {
					name: 'modulelist',
					id: 0,
					controlltype: 1,
					show: false
				},
			}
		},
		watch: {
			moduleid(v){
				this.gridShow = v
			}
		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			moduletTreeChange(e) {
			
				// this.modulename = e.name
				this.controller = e.controller
				this.parentbread = e.parentbread
				this.toolbarbutton = e.toolbarbutton
				this.operatebutton = e.operatebutton
				this.listfield = e.listfield
				if (e.toolbarbutton.length != 0 && e.operatebutton != 0) {
					this.moduleid = e.id
					this.customreload()
				} else {
					this.moduleid = 0
				}
				this.parentbread.map((item)=>{
					console.log(item)
				})
			},
			beforeRequest(form) {
				form.moduleid = this.moduleid
			},
			beforeCreateGrid(formConfig, columns, options) {
				options.pagerConfig = {
					layouts: [],
					currentPage: 1,
					pageSize: 999,

				}
			},
			add() {
				import('@_system/components/forms/moudel/controll/form.vue').then((res) => {
					this.formModule = {
						component: res.default,
						name: 'modulecontroll',
						id: 0,
						controlltype: 1,
						show: true,
						foreingKey: {
							moduleid: this.moduleid,
						},
						extra: {
							toolbarbutton: this.toolbarbutton,
							operatebutton: this.operatebutton,
							listfield: this.listfield
						}
					}
				})
			},
			edit(row) {
				import('@_system/components/forms/moudel/controll/form.vue').then((res) => {
					this.formModule = {
						component: res.default,
						name: 'modulecontroll',
						id: row.id,
						controlltype: 2,
						show: true,
						foreingKey: {
							moduleid: this.moduleid,
						},
						extra: {
							toolbarbutton: this.toolbarbutton,
							operatebutton: this.operatebutton,
							listfield: this.listfield
						}
					}
				})
			},
			del(row) {
				this.$confirm('是否删除 ' + row.name, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.modulecontroll.delete(row.id).then(() => {
						this.$message({
							message: '操作成功',
							type: 'success'
						})
						this.customreload()
					})
				}).catch(() => {

				})
			},
			listfieldconfig() {

				if (this.moduleid != 0) {
					//alert(123)

					import('@_system/components/forms/moudel/listfield/form.vue').then((res) => {

						this.formModule = {
							component: res.default,
							name: 'module',
							id: this.moduleid,
							controlltype: 2,
							show: true,
							foreingKey: {

							},
							extra: {
								controller: this.controller
							}
						}
					})
				} else {
					this.$message.error({
						message: '请选择模块',
					})
				}
			},
			auth(row) {
				import('@_system/components/forms/auth/form.vue').then((res) => {
					this.formModule = {
						component: res.default,
						name: 'auth',
						id: row.id,
						show: true,
						extra: {
							type: 'modulecontroll',
						}
					}
				})
			},
			formBack() {
				//let component = this.formModule.component
				if (this.formModule.name == 'module') {
					this.reloadlist()
					this.moduleid = 0
				}
				this.formModule = {
					component: '',
					name: '',
					id: 0,
					show: false,
					controlltype: 1,
					extra: {},
					foreingKey: {},
				}
				this.customreload()


			},
			reloadlist() {
				this.moduletTreeKey = Math.random()
			}
		},
		components: {
			moduleTree,


		}
	}
</script>
